export default "__VITE_ASSET__Be04UK5E__"